export enum TopPlayerListSortOrder {
  LOSER_INDEX_ASC = 'loserIndex:a',
  LOSER_INDEX_DESC = 'loserIndex:d',
}
